/* clone-cocosmooth: the page scripts, each in its own try/catch (generated, scripts/clone-shopify.py) */
try{
(function () {
var C = JSON.parse((document.getElementById('cart') || {}).textContent || '{}'), key = null, express = !!document.querySelector('.vf-express input:checked');
function link(items) {
var wait = items.filter(function (i) { return !/^\d+$/.test(i); });   // a variant that does not exist in Shopify yet
return wait.length ? '#' + wait.join('+') : C.cart + items.map(function (i) { return i + ':1'; }).join(',') + (C.suffix || '');
}
function render() {
document.querySelectorAll('.vf-buybox').forEach(function (box) {
var pick = null;
box.querySelectorAll('.vf-opt').forEach(function (o) { var on = o.getAttribute('data-key') === key; o.classList.toggle('vf-sel', on); o.querySelector('input').checked = on; if (on) pick = o; });
var ex = box.querySelector('.vf-express'); if (ex) { ex.classList.toggle('vf-on', express); ex.querySelector('input').checked = express; }
if (!pick) return;
var items = pick.getAttribute('data-items').split(' ').concat(express && ex ? ex.getAttribute('data-items').split(' ') : []);
var real = box.querySelector('.vf-links a[data-key="' + key + '"][data-ex="' + (express && ex ? 1 : 0) + '"]');
box.querySelector('.vf-order').href = real ? real.href : link(items);
});
}
var first = document.querySelector('.vf-opt.vf-pick') || document.querySelector('.vf-opt');
key = first && first.getAttribute('data-key');
document.querySelectorAll('.vf-opt').forEach(function (o) { o.addEventListener('click', function (e) { e.preventDefault(); key = o.getAttribute('data-key'); render(); }); });
document.querySelectorAll('.vf-express').forEach(function (x) { x.addEventListener('click', function (e) { e.preventDefault(); express = !express; render(); }); });
render();
document.querySelectorAll('.vf-buybox .vf-order').forEach(function (btn) {
btn.addEventListener('click', function (e) {
var box = btn.closest('.vf-buybox'), ex = box.querySelector('.vf-express');
var real = box.querySelector('.vf-links a[data-key="' + key + '"][data-ex="' + (express && ex ? 1 : 0) + '"]');
if (!real || real.getAttribute('href').charAt(0) === '#') return;   // a variant still pending: keep the plain link
e.preventDefault();
btn.classList.add('vf-loading'); btn.setAttribute('aria-busy', 'true'); var old = btn.textContent; btn.textContent = 'PLEASE WAIT…';
setTimeout(function () { btn.classList.remove('vf-loading'); btn.removeAttribute('aria-busy'); btn.textContent = old; }, 9000);
real.click();
});
});
document.querySelectorAll('.faq .faq-header').forEach(function (h) { h.addEventListener('click', function () { h.parentElement.classList.toggle('active'); }); });
var tl = document.querySelector('.vf-timeline ol');
if (tl) {
var fill = document.createElement('i'); fill.className = 'vf-tl-fill'; tl.appendChild(fill);
var steps = tl.querySelectorAll('li');
var grow = function () { var r = tl.getBoundingClientRect(), h = Math.max(0, Math.min(r.height - 34, innerHeight * 0.7 - r.top));
fill.style.height = h + 'px'; steps.forEach(function (li) { li.classList.toggle('vf-hit', li.offsetTop + 8 <= h); }); };
addEventListener('scroll', grow, { passive: true }); addEventListener('resize', grow); grow();
}
if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
document.documentElement.classList.add('vf-anim');
var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('vf-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
document.querySelectorAll('.vf-timeline li, .vf-feel-grid li, .vf-feel-grid img, .vf-reasons li, .vf-br, .vf-proof, .vf-expert blockquote, .vf-seal').forEach(function (el) { io.observe(el); });
document.querySelectorAll('.vf-ing-item').forEach(function (el) { io.observe(el); });
document.querySelectorAll('.vf-cmp-row:not(.vf-cmp-head)').forEach(function (el, k) { el.style.transitionDelay = (k * 0.08) + 's'; io.observe(el); });
}
document.querySelectorAll('.vf-car').forEach(function (car) {
var track = car.querySelector('.vf-car-track'), dots = car.querySelectorAll('.vf-car-dots i'), cards = track.children;
var mark = function () { var mid = track.scrollLeft + track.clientWidth / 2, best = 0;
[].forEach.call(cards, function (c, k) { if (Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid) < Math.abs(cards[best].offsetLeft + cards[best].offsetWidth / 2 - mid)) best = k; });
[].forEach.call(dots, function (d, k) { d.classList.toggle('on', k === best); }); };
track.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true }); mark();
});
function topBars() {
var h = 0;
document.querySelectorAll('[data-sticky_position="top"], .sticky, header').forEach(function (el) {
var cs = getComputedStyle(el), r = el.getBoundingClientRect();
if ((cs.position === 'sticky' || cs.position === 'fixed') && r.height > 0 && r.height < innerHeight / 3 && r.top <= 1) h = Math.max(h, r.bottom);
});
return h;
}
var EYE = 0.38;
function glide(t) {
var where = function () {
var card = t.querySelector('.vf-opt.vf-pick') || t.querySelector('.vf-opt.vf-sel') || t.querySelector('.vf-opt') || t, r = card.getBoundingClientRect();   // always the pre-selected pack, whatever the reader ticked since
var y = r.top + scrollY + r.height / 2 - innerHeight * EYE;
return Math.max(0, Math.min(y, r.top + scrollY - topBars() - 8));   // never so far that the card hides behind a bar fixed at the top
};
scrollTo({ top: where(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
var fix = function () { if (Math.abs(scrollY - where()) > 4) scrollTo({ top: where(), behavior: 'auto' }); };
setTimeout(fix, 900); setTimeout(fix, 1600);
}
document.querySelectorAll('.btn:not(a), button.btn').forEach(function (el) { if (el.closest('.vf, .pol-ov, a')) return; el.style.cursor = 'pointer'; el.setAttribute('role', 'link');
el.addEventListener('click', function (e) { var t = document.querySelector('#vf-buy'); if (t) { e.preventDefault(); glide(t); } }); });
document.querySelectorAll('a[href^="#vf-"]').forEach(function (a) { a.addEventListener('click', function (e) { var t = document.querySelector(a.getAttribute('href')); if (t) { e.preventDefault(); glide(t); } }); });
})();
}catch(e){console.error("clone-cocosmooth script 1", e)}
try{
(function(){
var g=document.querySelector('.g9-gal'); if(!g) return;
var tr=g.querySelector('.g9-track'), th=[].slice.call(g.querySelectorAll('.g9-thumbs button')), n=th.length;
function cur(){return Math.round(tr.scrollLeft/Math.max(1,tr.clientWidth));}
function go(i){i=Math.max(0,Math.min(n-1,i));tr.scrollTo({left:i*tr.clientWidth,behavior:'smooth'});}
function mark(){var c=cur();th.forEach(function(b,i){b.classList.toggle('on',i===c);});}
th.forEach(function(b,i){b.addEventListener('click',function(){go(i);});});
g.querySelector('.g9-arr.l').addEventListener('click',function(){go(cur()-1);});
g.querySelector('.g9-arr.r').addEventListener('click',function(){go(cur()+1);});
tr.addEventListener('scroll',function(){clearTimeout(tr._t);tr._t=setTimeout(mark,60);});
mark();
})();
}catch(e){console.error("clone-cocosmooth script 2", e)}
try{
(function () {
var root = document.documentElement, s = document.querySelector('script.kaching-bundles-deal-block-settings');
if (!(s && s.textContent.replace(/\s/g, '').length > 2)) return;
root.classList.add('kd');
var zs = function (hide) { document.querySelectorAll('.vf-kz').forEach(function (k) { k.hidden = hide; }); }; zs(false);
setTimeout(function () { if (!document.querySelector('.vf-kz .kaching-bundles__bar')) { root.classList.remove('kd'); zs(true); } }, 10000);
var EYE = 0.30;   // the top of the pre-selected bar (its badge included) sits at about 30% of the screen
function target() { var z = document.querySelector('#vf-buy .vf-kz') || document.querySelector('.vf-kz');
return z && (z.querySelector('.kaching-bundles__bar--selected') || z.querySelector('.kaching-bundles__bar') || z); }
function topBars() { var h = 0; document.querySelectorAll('[data-sticky_position="top"], .sticky, header').forEach(function (el) { var cs = getComputedStyle(el), r = el.getBoundingClientRect();
if ((cs.position === 'sticky' || cs.position === 'fixed') && r.height > 0 && r.height < innerHeight / 3 && r.top <= 1) h = Math.max(h, r.bottom); }); return h; }
function glide() {
var where = function () { var t = target(); if (!t) return scrollY; var r = t.getBoundingClientRect(); return Math.max(0, Math.min(r.top + scrollY - innerHeight * EYE, r.top + scrollY - topBars() - 8)); };
scrollTo({ top: where(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
var fix = function () { if (Math.abs(scrollY - where()) > 4) scrollTo({ top: where(), behavior: 'auto' }); };
setTimeout(fix, 900); setTimeout(fix, 1600);
}
document.addEventListener('click', function (e) {
if (!root.classList.contains('kd')) return;
var a = e.target.closest('a[href^="#vf-"]'), b = e.target.closest('.btn:not(a), button.btn');
if (b && b.closest('.vf, .pol-ov, a')) b = null;
if (!a && !b) return;
e.preventDefault(); e.stopImmediatePropagation(); glide();
}, true);
})();
}catch(e){console.error("kaching bridge", e)}